var AVLists = /** @class */ (function () {
    function AVLists() {
    }
    return AVLists;
}());
export { AVLists };
